import React, { useEffect, useState } from 'react';
import { NavLink, useSearchParams } from 'react-router-dom';
import { BASE_URL } from '../../utils/Constants';
import axios from 'axios';
import Swal from 'sweetalert2';



const AssingCourse = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    let id = searchParams.get("id");
    const [assignedCourses, setAssignedCourses] = useState([])
    const [unAssignedCourses, setUnAssignedCourses] = useState([])
    const [change , setChange] = useState(false);
    const [user,setUser] = useState<any>()
    useEffect(() => {
        axios.get(`${BASE_URL}/users/getusercourses.php?id=${id}`).then((res: any) => {
            setAssignedCourses(res.data.data.assigned_courses)
            setUnAssignedCourses(res.data.data.un_assigned_courses)
            setUser(res.data.data.user)
        })
    }, [change])


    const handleAssignCourse = (course_id: any) => {
        axios.post(`${BASE_URL}/users/assigncourse.php`, { course_id, user_id: id }).then((res: any) => {
            Swal.fire("Course addedd successfully", "", "success").then(() => {
             setChange(!change)
            })
        })
    }
    const handleRemoveCourse = (course_id: any) => {
        axios.post(`${BASE_URL}/users/removeuserfromcourse.php`, { course_id, user_id: id }).then((res: any) => {
            Swal.fire("Course addedd successfully", "", "success").then(() => {
             setChange(!change)
            })
        })
    }
    return (
        <div>

<NavLink to={"/users"} className="btn btn-secondary"><i className="bi bi-arrow-left" style={{color:"white"}}></i></NavLink>

            <h2 className='text-center'>Manage user Email  :  <span className="text-primary"> {user?.email}</span></h2>
            <h2 className='text-success'>User Courses</h2>
            <div className="table-responsive">
                <table id="dataTable" className="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">id</th>
                            <th scope="col">Name </th>
                            <th scope="col">End date </th>
                            <th scope="col">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {assignedCourses?.map((course: any) => {
                            return (
                                <tr>
                                    <th scope="row">{course.id}</th>
                                    <td>{course.name}</td>
                                    <td>{course.end_date}</td>
                                    <td>
                                    <button onClick={()=>{handleRemoveCourse(course.id)}} className="btn btn-danger ">Remove </button>

                                    </td>
                                </tr>
                            )
                        })}

                    </tbody>
                </table>
            </div>

            <hr className="mb-5 mt-5"></hr>
            <h2 className='text-danger'>Unsubscribed Courses</h2>

            <div className="table-responsive">
                <table id="dataTable" className="table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">id</th>
                            <th scope="col">Name </th>
                            <th scope="col">Actions </th>
                        </tr>
                    </thead>
                    <tbody>
                        {unAssignedCourses?.map((course: any) => {
                            return (
                                <tr>
                                    <th scope="row">{course.id}</th>
                                    <td>{course.name}</td>
                                    <td>
                                        <button onClick={() => { handleAssignCourse(course.id) }} className="btn btn-primary ">Assign </button>

                                    </td>
                                </tr>
                            )
                        })}

                    </tbody>
                </table>
            </div>

        </div>
    )
}


export default AssingCourse